import * as yup from "yup";
import { MeetingOffsetUnit } from "../Timing/models";

export const occurrenceSelectionSchema = yup.object({
  referenceEvent: yup.mixed<"start_date">().required().label("Reference Event"),
  offset: yup.number().required().integer().label("Offset"),
  offsetUnit: yup.mixed<MeetingOffsetUnit>().when("offset", {
    is: (value: number) => value !== 0,
    then: (schema) => schema.required().label("Offset Unit"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export type OccurrenceSelectionSchema = yup.InferType<typeof occurrenceSelectionSchema>;


